// Keeps the user's files and settings in IndexedDB so a page refresh or the login step
// does not lose the print job. Everything is best-effort: failures are swallowed.
const DB_NAME = "printanywhere-web";
const STORE = "files";

function openDb() {
  return new Promise((resolve, reject) => {
    if (typeof indexedDB === "undefined") {
      reject(new Error("IndexedDB unavailable"));
      return;
    }
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      if (!req.result.objectStoreNames.contains(STORE)) req.result.createObjectStore(STORE, { keyPath: "id" });
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function tx(db, mode, fn) {
  return new Promise((resolve, reject) => {
    const t = db.transaction(STORE, mode);
    const store = t.objectStore(STORE);
    const result = fn(store);
    t.oncomplete = () => resolve(result && result.result !== undefined ? result.result : undefined);
    t.onerror = () => reject(t.error);
    t.onabort = () => reject(t.error);
  });
}

export async function saveFileRecords(records) {
  try {
    const db = await openDb();
    await tx(db, "readwrite", (store) => {
      store.clear();
      records.forEach((r, order) => store.put({ ...r, order }));
    });
    db.close();
  } catch (e) {
    /* ignore */
  }
}

export async function loadFileRecords() {
  try {
    const db = await openDb();
    const rows = await new Promise((resolve, reject) => {
      const t = db.transaction(STORE, "readonly");
      const req = t.objectStore(STORE).getAll();
      req.onsuccess = () => resolve(req.result || []);
      req.onerror = () => reject(req.error);
    });
    db.close();
    return rows.sort((a, b) => (a.order || 0) - (b.order || 0));
  } catch (e) {
    return [];
  }
}

export async function clearFileRecords() {
  return saveFileRecords([]);
}

const SESSION_KEYS = { location: "pa_location", pending: "pa_pending_order", next: "pa_next" };

export function sessionGet(key) {
  try {
    const raw = sessionStorage.getItem(SESSION_KEYS[key] || key);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function sessionSet(key, value) {
  try {
    const k = SESSION_KEYS[key] || key;
    if (value === null || value === undefined) sessionStorage.removeItem(k);
    else sessionStorage.setItem(k, JSON.stringify(value));
  } catch (e) {
    /* ignore */
  }
}
